// extracted by mini-css-extract-plugin
export default {"Arrow":"Slick_Arrow__+kgg9","Arrow--Hidden":"Slick_Arrow--Hidden__9zHeA","carouselContainer":"Slick_carouselContainer__E02ld"};